"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = exports.isNonEmptyString = exports.isNullOrUndef = void 0;
function isNullOrUndef(value) {
    return value === null || value === undefined;
}
exports.isNullOrUndef = isNullOrUndef;
function isNonEmptyString(obj) {
    if (typeof obj !== 'string') {
        return false;
    }
    return obj.length !== 0;
}
exports.isNonEmptyString = isNonEmptyString;
function isObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
}
exports.isObject = isObject;
